import _asyncToGenerator from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useCallback, useEffect, useState } from 'react';
import { useNavigationContext } from '../context';
export var FB_PIXEL_ID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID;
var isProd = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production';
export function useFacebookPixel() {
  var _useState = useState(false),
      isActive = _useState[0],
      setIsActive = _useState[1];

  var _useNavigationContext = useNavigationContext(),
      router = _useNavigationContext.router;

  var init = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var ReactPixel;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!FB_PIXEL_ID || false)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            _context.next = 4;
            return import('react-facebook-pixel');

          case 4:
            ReactPixel = _context.sent["default"];
            setIsActive(true);
            ReactPixel.init(FB_PIXEL_ID, undefined, {
              autoConfig: true,
              debug: !isProd
            });
            ReactPixel.pageView();

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), []);
  useEffect(function () {
    init();
    router === null || router === void 0 ? void 0 : router.events.on('routeChangeComplete', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var ReactPixel;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return import('react-facebook-pixel');

            case 2:
              ReactPixel = _context2.sent["default"];
              ReactPixel.pageView();

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
  }, [router === null || router === void 0 ? void 0 : router.events, init]);
  var trackWorkerApplied = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var ReactPixel;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (isActive) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return");

          case 2:
            _context3.next = 4;
            return import('react-facebook-pixel');

          case 4:
            ReactPixel = _context3.sent["default"];
            ReactPixel.trackCustom('WorkerApplied', {
              content_category: 'B2C'
            });

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), [isActive]);
  var trackWorkerStartsApplication = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var ReactPixel;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (isActive) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return");

          case 2:
            _context4.next = 4;
            return import('react-facebook-pixel');

          case 4:
            ReactPixel = _context4.sent["default"];
            ReactPixel.trackCustom('WorkerStartApplication', {
              content_category: 'B2C'
            });

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  })), [isActive]);
  var trackWorkerSavedResearch = useCallback( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref5) {
      var user_id, frequency, ReactPixel;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              user_id = _ref5.user_id, frequency = _ref5.frequency;

              if (isActive) {
                _context5.next = 3;
                break;
              }

              return _context5.abrupt("return");

            case 3:
              _context5.next = 5;
              return import('react-facebook-pixel');

            case 5:
              ReactPixel = _context5.sent["default"];
              ReactPixel.trackCustom('WorkerSaveResearch', {
                user_id: user_id,
                frequency: frequency,
                content_category: 'B2C'
              });

            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x) {
      return _ref6.apply(this, arguments);
    };
  }(), [isActive]);
  var trackWorkerAppliesSpontaneously = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var ReactPixel;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (isActive) {
              _context6.next = 2;
              break;
            }

            return _context6.abrupt("return");

          case 2:
            _context6.next = 4;
            return import('react-facebook-pixel');

          case 4:
            ReactPixel = _context6.sent["default"];
            ReactPixel.trackCustom('WorkerAppliesSpontaneously', {
              content_category: 'B2C'
            });

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  })), [isActive]);
  var trackEmployerSignup = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var ReactPixel;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (isActive) {
              _context7.next = 2;
              break;
            }

            return _context7.abrupt("return");

          case 2:
            _context7.next = 4;
            return import('react-facebook-pixel');

          case 4:
            ReactPixel = _context7.sent["default"];
            ReactPixel.track('CompleteRegistration', {
              content_name: 'Employer Signup',
              content_category: 'B2B'
            });

          case 6:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  })), [isActive]);
  var trackPurchase = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    var ReactPixel;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (isActive) {
              _context8.next = 2;
              break;
            }

            return _context8.abrupt("return");

          case 2:
            _context8.next = 4;
            return import('react-facebook-pixel');

          case 4:
            ReactPixel = _context8.sent["default"];
            ReactPixel.track('Purchase', {
              content_category: 'B2B',
              currency: 'EUR',
              value: 19.9
            });

          case 6:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  })), [isActive]);
  var trackPublishJP = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    var ReactPixel;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (isActive) {
              _context9.next = 2;
              break;
            }

            return _context9.abrupt("return");

          case 2:
            _context9.next = 4;
            return import('react-facebook-pixel');

          case 4:
            ReactPixel = _context9.sent["default"];
            ReactPixel.trackCustom('PublishJP', {
              content_category: 'B2B'
            });

          case 6:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  })), [isActive]);
  return {
    isActive: isActive,
    trackWorkerApplied: trackWorkerApplied,
    trackWorkerStartsApplication: trackWorkerStartsApplication,
    trackWorkerSavedResearch: trackWorkerSavedResearch,
    trackEmployerSignup: trackEmployerSignup,
    trackWorkerAppliesSpontaneously: trackWorkerAppliesSpontaneously,
    trackPurchase: trackPurchase,
    trackPublishJP: trackPublishJP
  };
}